import styled from "styled-components";

const GraphDisclaimer = styled.p`
  text-align: center;
  font-size: 12px;
  color: #82878b;
  margin: -15px 0;
`;

const UL = styled.ul`
  width: 80%;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 30px auto;

  @media (max-width: 480px) {
    margin-top: 45px;
  }

  div {
    width: 100px;
    height: 5px;
    background-color: black;
    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;

const LI = styled.li`
  width: 30%;
  height: 60px;
  margin-top: 10px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  font-weight: 600;
  color: black;

  @media (max-width: 480px) {
    font-size: 11px;
    font-weight: 600;
    display: flex;
    text-align: center;
    justify-content: flex-end;
    align-items: flex-end;
  }

  div {
    background-color: ${(p) => p.color || "black"};
  }
`;

const CustomLegend = (props) => (
  <>
    <UL>
      {props?.payload.map((entry, index) => (
        <LI key={`item-${index}`} color={entry.color}>
          {entry.payload.id === "strongMarket"
            ? "Projected Annual Return"
            : entry.payload.id === "weakMarket"
            ? "Weak Market"
            : "Average Market"}
          <div></div>
        </LI>
      ))}
    </UL>
    <GraphDisclaimer>
      *Actual results may differ from the theoretical forecast presented. All
      investment strategies and investments involve the risk of loss. The value
      of the investments can go down as well as up.
    </GraphDisclaimer>
  </>
);

export default CustomLegend;
